<template>
  <div class="page-admin">
<json-csv
  ref="csvDownload"
  :data="csvData"
  :name="csvFilename"
  style="display: none;"
>
</json-csv>



    <section class="bg10 bs-shadow mobile-top" style="padding: 20px 0;">
      <div class="container">
        <div>
        <div class="row" data-v-fbf4b22c="">
          <div class="col-xs-12 col-sm-12 col-12 col-lg-6" data-v-fbf4b22c="">
            <div
              style="display: flex; height: 100%; align-items: center"
              data-v-fbf4b22c=""
            >
              <h1
                class="page-heading"
                style="color: #fff; font-size: 31px"
                data-v-fbf4b22c=""
              >
                Sales & Marketing Agent Report
              </h1>
            </div>
          </div>
          <div
            class="col-xs-12 col-sm-12 col-12 col-lg-7"
            style="display: flex; justify-content: center; align-items: center"
          >
            <div style="margin-left: auto"></div>
          </div>
        </div>




<div class="row">
  <div class="col-lg-12">   <!-- Changed to full width for better control -->
    <div style="display: flex; justify-content: flex-start; align-items: center; gap: 5px;">
      
      <button
        class="filter-btn"
        style="padding: 5px 10px; margin-left: 0;"
        @click="setView('company')"
      >
        Company Stats
      </button>

      <button
        class="filter-btn"
        style="padding: 5px 10px;"
        @click="setView('user')"
      >
        User Stats
      </button>
       <button
        class="filter-btn"
        style="padding: 5px 10px; margin-right: auto;"
        @click="setView('keywords')"
      >
        Keyword Stats
      </button>



    </div>
  </div>
</div>

<div class="row" style="margin-top: 10px;">
  <div class="container">
               <div class="radios">
              <div class="control-group">
                <label class="control control--radio">
                  All Time
                  <input
                    type="radio"
                    name="radio"
                    checked="checked"
                    v-model="timePeriod"
                    value="all"
                  />
                  <div class="control__indicator"></div>
                </label>
                <label class="control control--radio">
                  Last 30 Days
                  <input
                    type="radio"
                    name="radio"
                    v-model="timePeriod"
                    value="30"
                  />
                  <div class="control__indicator"></div>
                </label>
                <!--
                <label id="EO-step-3" class="control control--radio">
                  Completed
                  <input
                    type="radio"
                    name="radio"
                    v-model="picked"
                    value="completed"
                  />
                  <div class="control__indicator"></div>
                </label>
                -->
              </div>
            </div>
  </div>
</div>

      <button 
    class="mb0 lh1 mlauto list-btn dib d-flex center"
    style="background: #4d5967; margin-left: auto; padding: 5px 10px!important;     max-height: 40px; border: none;"
    @click="downloadCSV"
  >
    Download CSV
  </button>
      </div>
      </div>
    </section>

    <div class="container">
      <div class="row">
        <!--
        <div class="col-lg-4 d-none d-lg-block">
          <div class="card-block my-3 bs-shadow">
            <h5 class="dflex">
              <i class="material-icons">help</i> Using the Admin Section
            </h5>
            <hr />
            <div>
              <p class="info-box">
                You can search above by a user's first name, last name, or by
                company name of their employer.
              </p>
              <p class="info-box mb0">
                You can also filter your results by clicking on the company name
                in the user results area.
              </p>
            </div>
          </div>
        </div>
        -->

        <div
          v-if="loading == true"
          class="col-xs-12 col-sm-12 col-12 col-lg-12"
        >
          <div class="flex-box-wrap" style="margin: 150px 0">
            <div class="flex-internal">
              <atom-spinner
                :animation-duration="1000"
                :size="40"
                :color="'#575757'"
              />
              <p>Loading......</p>
            </div>
          </div>
        </div>

        <div
          v-else-if="loading == false && !companyStats"
          class="col-xs-12 col-sm-12 col-12 col-lg-12 flexVHcenter"
        >
          <div style="margin: 150px 0">
            <img src="@/assets/img/sad.svg" />
            <p>Sorry, nothing was found...</p>
          </div>
        </div>

        <div v-else-if="loading == false && companyStats && view == 'company'" class="col-xs-12 col-sm-12 col-12 col-lg-12" style="background: #fff; margin: 20px 0;">
         
          <h5 style="margin-top: 20px;">Agent Use By Company</h5>
          <div>
                  <div class="table-responsive">
                      <table
                        class="table-striped table-bordered"
                        style="display: table; width: 100%; margin-bottom: 20px;"
                      >
                        <thead>
                          <tr>
                     
                        
                       
                   
                            <th
                              scope="col"
                              class="table-link twenty"
                              style="padding: 6px;"
                              :class="
                                columnSort == 'whenAdded' ? 'column-active' : ''
                              "
                            >
                              <span style="display: flex; flex: 0 0 100%">
                                <span style="color: #fff;">Company </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              class="table-link twenty"
                              style="padding: 6px;"
                              :class="
                                columnSort == 'whenAdded' ? 'column-active' : ''
                              "
                            >
                              <span style="display: flex; flex: 0 0 100%">
                                <span style="color: #fff;">Prompt Count </span>
                              </span>
                            </th>
                            
                  
                            
                            
                            
                           
                    
                            
                            
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            scope="row"
                            v-bind:key="index"
                            v-for="(company, index) in companyStats.companies"
                          >
                           
                          
                            <td>
                              <span>{{ company.CompanyName }}</span>
                            </td>
                             <td>
                              <span>{{ company.UserMessageCount }}</span>
                            </td>

                           
                         
                            
                      
                            
                            
                          
                          
                          </tr>
                        </tbody>
                      </table>
                    </div>

     
          </div>

        </div>

         <div v-else-if="loading == false && companyStats && view == 'user'" class="col-xs-12 col-sm-12 col-12 col-lg-12" style="background: #fff; margin: 20px 0;">
         
          <h5 style="margin-top: 20px;">Top Users</h5>
          <div>
                  <div class="table-responsive">
                      <table
                        class="table-striped table-bordered"
                        style="display: table; width: 100%; margin-bottom: 20px;"
                      >
                        <thead>
                          <tr>
                     
                        
                       
                   
                            <th
                              scope="col"
                              class="table-link twenty"
                              style="padding: 6px;"
                              :class="
                                columnSort == 'whenAdded' ? 'column-active' : ''
                              "
                            >
                              <span style="display: flex; flex: 0 0 100%">
                                <span style="color: #fff;">Company </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              class="table-link twenty"
                              style="padding: 6px;"
                              :class="
                                columnSort == 'whenAdded' ? 'column-active' : ''
                              "
                            >
                              <span style="display: flex; flex: 0 0 100%">
                                <span style="color: #fff;">User</span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              class="table-link twenty"
                              style="padding: 6px;"
                              :class="
                                columnSort == 'whenAdded' ? 'column-active' : ''
                              "
                            >
                              <span style="display: flex; flex: 0 0 100%">
                                <span style="color: #fff;">Prompt Count </span>
                              </span>
                            </th>
                            
                  
                            
                            
                            
                           
                    
                            
                            
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            scope="row"
                            v-bind:key="index"
                            v-for="(user, index) in userStats.slice(0, 29)"
                          >
                           
                          
                            <td>
                              <span>{{ user.CompanyName }}</span>
                            </td>
                             <td>
                              <span>{{ user.UserName }}</span>
                            </td>
                             <td>
                              <span>{{ user.MessageCount }}</span>
                            </td>

                           
                         
                            
                      
                            
                            
                          
                          
                          </tr>
                        </tbody>
                      </table>
                    </div>

     
          </div>

        </div>


      <div v-else-if="loading == false && companyStats && view == 'keywords'" class="col-xs-12 col-sm-12 col-12 col-lg-12" style="background: #fff; margin: 20px 0;">
        <div class="keyword-stats">
          <h5 style="margin-top: 20px;">Keyword Use</h5>
          <div class="table-responsive">
          <table class="table-striped table-bordered"
                              style="display: table; width: 100%; margin-bottom: 20px;">
            <thead>
              <tr>
                <!-- Specified Keywords -->
                <th colspan="2" scope="col" class="table-link twenty" style="color: #fff; padding: 6px;"> <span>Specified Keywords</span></th>
                
                <!-- Top Unigrams -->
                <th colspan="2" scope="col" class="table-link twenty" style="color: #fff; padding: 6px;"> <span>Top Unigrams</span></th>
                
                <!-- Top Bigrams -->
                <th colspan="2" scope="col" class="table-link twenty" style="color: #fff; padding: 6px;"> <span>Top Bigrams</span></th>
                
                <!-- Top Trigrams -->
                <th colspan="2" scope="col" class="table-link twenty" style="color: #fff; padding: 6px;"> <span>Top Trigrams</span></th>
              </tr>
              <tr>
                <th>Term</th>
                <th style="max-width: 40px!important;">Count</th>
                <th>Term</th>
                <th style="max-width: 90px;">Count</th>
                <th>Term</th>
                <th style="max-width: 90px;">Count</th>
                <th>Term</th>
                <th style="max-width: 90px;">Count</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in horizontalKeywordRows" :key="index">
                <td>{{ row.specifiedTerm }}</td>
                <td style="max-width: 40px;">{{ row.specifiedCount }}</td>
                
                <td>{{ row.unigramTerm }}</td>
                <td>{{ row.unigramCount }}</td>
                
                <td>{{ row.bigramTerm }}</td>
                <td>{{ row.bigramCount }}</td>
                
                <td>{{ row.trigramTerm }}</td>
                <td>{{ row.trigramCount }}</td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>
        <!-- end table -->
        <!-- end other column -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
import Avatar from "../components/Atoms/Avatar.vue";
import JsonCSV from "vue-json-csv";
import vSelect from "vue-select";
import { thresholdSturges } from "d3";

const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    //Authorization: "Bearer " + wontworkqwd2iwedjqoewiudwo
  },
};

export default {
  name: "ProductChatReport",
  components: {
    AtomSpinner,
    Avatar,
    JsonCSV,
    vSelect,
  },
  data() {
    return {
      server: import.meta.env.VITE_APP_SERVER_URL,
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      staging: "http://localhost:5002/api/v1/admin/user/create",
      stage: "http://localhost:5002",
      keywordServer: "https://spacenet3api.spacesaver.com/api/v1//analyze-keywords",
      topUserServer: "https://spacenet3api.spacesaver.com/api/v1/top-users",
      companyUserServer: "https://spacenet3api.spacesaver.com/api/v1/company-message-counts",
      timePeriod: "all",
      companyStats: null,
      userStats: null,
      keywordStats: null,
      view: "company",
      csvData: [],
      csvFilename: 'report.csv',
      search: "",
      firstName: "",
      lastName: "",
      selectedCompany: "",
      active: true,
      acs: [],
      users: [],
      selectedCat: 0,
      loading: true,
      countOfPage: 25,
      currPage: 1,
    };
  },
  methods: {
    firstLoad: function () {
      this.loading = true;
      this.$store.commit("setActivePage", "Admin");

      this.getCompanyStats();
      // this.getUserStats();
      // this.getKeywordStats();
    },

    getCompanyStats() {
  this.loading = true;
  let url = this.companyUserServer;

  // Only add ?days=30 if timePeriod is "30"
  if (this.timePeriod === "30") {
    url += "?days=30";
  }

  axios
    .get(url, auth)
    .then((response) => {
      this.companyStats = response.data;
      this.loading = false;
    })
    .catch((error) => {
      console.error("Error fetching company stats:", error);
      this.loading = false;
      if (error.response?.status === 401) this.$router.push("/");
    });
},

getUserStats() {
  this.loading = true;
  let url = this.topUserServer;

  if (this.timePeriod === "30") {
    url += "?days=30";
  }

  axios
    .get(url, auth)
    .then((response) => {
      this.userStats = response.data.top_users;
      this.loading = false;
    })
    .catch((error) => {
      console.error("Error fetching user stats:", error);
      this.loading = false;
      if (error.response?.status === 401) this.$router.push("/");
    });
},

getKeywordStats() {
  this.loading = true;
  let url = this.keywordServer;

  if (this.timePeriod === "30") {
    url += "?days=30";
  }

  axios
    .get(url, auth)
    .then((response) => {
      this.keywordStats = response.data;
      this.loading = false;
    })
    .catch((error) => {
      console.error("Error fetching keyword stats:", error);
      this.loading = false;
      if (error.response?.status === 401) this.$router.push("/");
    });
},
setView(view) {
    this.view = view;
    // Refresh data when switching views
    if (view === 'company') this.getCompanyStats();
    else if (view === 'user') this.getUserStats();
    else if (view === 'keywords') this.getKeywordStats();
  },
downloadCSV() {
  let data = [];
  let baseName = "report";

  // Better filenames as requested
  if (this.view === 'company') {
    baseName = "company_report";
  } else if (this.view === 'user') {
    baseName = "user_report";
  } else if (this.view === 'keywords') {
    baseName = "keyword_report";
  }

  const timeSuffix = this.timePeriod === "30" ? "_30days" : "_alltime";
  const filename = `${baseName}${timeSuffix}`;

  // ── Prepare Data ─────────────────────────────────────
  if (this.view === 'company' && this.companyStats?.companies?.length) {
    data = this.companyStats.companies.map(c => ({
      Company: c.CompanyName || '',
      "Prompt Count": c.UserMessageCount || 0
    }));

  } else if (this.view === 'user' && this.userStats?.length) {
    data = this.userStats.slice(0, 100).map(u => ({
      Company: u.CompanyName || '',
      User: u.UserName || '',
      "Prompt Count": u.MessageCount || 0
    }));

  } else if (this.view === 'keywords' && this.keywordStats) {
    data = [];

    // Specified Keywords
    (this.keywordStats.specified_keywords || []).forEach(item => {
      data.push({
        Category: "Specified Keyword",
        Term: item.term,
        Count: item.count,
        Percentage: item.percentage || ''
      });
    });

    // Top Unigrams
    (this.keywordStats.top_unigrams || []).forEach(item => {
      data.push({
        Category: "Top Unigram",
        Term: item.term,
        Count: item.count,
        Percentage: item.percentage || ''
      });
    });

    // Top Bigrams
    (this.keywordStats.top_bigrams || []).forEach(item => {
      data.push({
        Category: "Top Bigram",
        Term: item.term,
        Count: item.count,
        Percentage: item.percentage || ''
      });
    });
  }

  if (data.length === 0) {
    this.$toast.warning("No data to download");
    return;
  }

  // Convert to CSV and download
  const csvContent = this.convertToCSV(data);
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement("a");

  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", `${filename}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
},

// Helper function (keep this)
convertToCSV(items) {
  if (items.length === 0) return '';

  const headers = Object.keys(items[0]);
  let csv = headers.join(",") + "\n";

  items.forEach(item => {
    const row = headers.map(header => {
      let val = item[header] ?? '';
      if (typeof val === 'string' && (val.includes(',') || val.includes('"'))) {
        val = `"${val.replace(/"/g, '""')}"`;
      }
      return val;
    });
    csv += row.join(",") + "\n";
  });

  return csv;
},

// Helper function
convertToCSV(items) {
  if (items.length === 0) return '';

  const headers = Object.keys(items[0]);
  let csv = headers.join(",") + "\n";

  items.forEach(item => {
    const row = headers.map(header => {
      let val = item[header] ?? '';
      // Escape commas and quotes
      if (typeof val === 'string' && (val.includes(',') || val.includes('"'))) {
        val = `"${val.replace(/"/g, '""')}"`;
      }
      return val;
    });
    csv += row.join(",") + "\n";
  });

  return csv;
},












    updateURL() {
      const queryParams = [];
      //const page = urlParams.get("page") || "";
      if (this.firstName.trim().length > 0) {
        queryParams.push(`first=${encodeURIComponent(this.firstName.trim())}`);
      }
      if (this.lastName.trim().length > 0) {
        queryParams.push(`last=${encodeURIComponent(this.lastName.trim())}`);
      }
      if (this.acFilter !== null && this.acFilter !== undefined) {
        queryParams.push(`company=${encodeURIComponent(this.acFilter)}`);
      }
      if (this.active || !this.active) {
        queryParams.push(`active=${encodeURIComponent(this.active)}`);
      }

      const newURL = `${window.location.pathname}?${queryParams.join("&")}`;
      window.history.pushState({}, "", newURL);
      this.firstLoad();
      // window.location.href = newURL;
    },

    searchReset: function () {
      this.firstName = "";
      this.lastName = "";
      this.acFilter = null;
      this.active = true;
      this.updateURL();
    },

    setPage: function (idx) {
      this.search = "";
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      this.currPage = idx;
    },

    catSwitcher: function (catID) {
      let category = catID;
      if (category !== 0) {
        this.selectedCat = category;
        this.search = "";
        console.log(category);
      } else {
        this.selectedCat = 0;
      }
    },

    setCompany(c) {
      this.search = "";
      let company = c;
      this.selectedCompany = company;
    },
    impersonate(id, email) {
      var postData = {
        id: id,
        email: email,
      };

      console.log(postData);

      this.$store
        .dispatch("impersonateUser", postData)
        .then(() => {
          // this.$noty.success("Successfully logged in!");
          
          this.$router.push("/Home");
          
        })
        .catch((err) => {
          //console.log(err)
          this.feedback = "There seems to be an issue with your credentials.";
        });
    },
    deleteUserAccount(first, last, id, email) {
      console.log(id);
      console.log(email);
      this.deleteUserOverlay = true;
      this.UserToDelete = {
        UserFirst: first,
        UserLast: last,
        UserId: id,
        Email: email,
      };
    },
    deleteConfirm(id) {
      console.log(id);
      const deleteURL = this.server + "/api/v1/admin/user/delete"; // Declare with const
      console.log(`${deleteURL}`);
      return axios
        .post(
          `${deleteURL}`,
          {
            userID: id,
          },
          auth
        )
        .then((response) => {
          console.log("Response:", response);
          if (response.status === 401) {
              // this.Logout();
              this.$router.push("/");
          } else {
          this.firstName = ""
          this.lastName = ""
          this.$router.replace({
            ...this.$route,
            query: {}, // Set query to an empty object to remove all params
          });
          this.deleteModalClose();
          this.firstLoad();
          this.$toast.success(
            `The user has been successfully deleted`,
            {
              hideProgressBar: false,
              position: "bottom-right",
              icon: false,
              timeout: 10000,
            }
          );
          }
        })
        .catch((error) => {
          console.error("Error during POST request:", error);
          this.$toast.error(
            `There was an issue deleting ${
              this.UserToDelete.UserFirst + " " + this.UserToDelete.UserLast
            }`,
            {
              hideProgressBar: false,
              position: "bottom-right",
              icon: false,
              timeout: 10000,
            }
          );
        });
    },

    activateUserAccount(FirstName, LastName, UserId, Email, RepID) {
      this.activateUserOverlay = true;
      this.emailConfirmActivate = Email;
      this.RepIDConfirmActivate = null;
      this.UserToActivate.userFirst = FirstName;
      this.UserToActivate.userLast = LastName;
      this.UserToActivate.userId = UserId;
      this.UserToActivate.Email = Email;
      this.UserToActivate.RepID = RepID;
    },
    deactivateUserAccount(FirstName, LastName, UserId, Email, RepID) {
      this.deactivateUserOverlay = true;
      this.emailConfirmDeactivate = "TERM" + Email;
      this.RepIDConfirmDeactivate = null;
      this.UserToDeactivate.userFirst = FirstName;
      this.UserToDeactivate.userLast = LastName;
      this.UserToDeactivate.userId = UserId;
      this.UserToDeactivate.Email = Email;
      this.UserToDeactivate.RepID = RepID;
    },

    deactivateConfirm(UserId, Email) {
      console.log(UserId, Email);
      const deactivateURL = this.server + "/api/v1/admin/user/deactivate"; // Declare with const
      console.log(`${deactivateURL}`);
      return axios
        .post(
          `${deactivateURL}`,
          {
            UserID: UserId,
            Email: Email,
          },
          auth
        )
        .then((response) => {
          console.log("Response:", response);
          this.$toast.success(
            `The user has been successfully deactivated`,
            {
              hideProgressBar: false,
              position: "bottom-right",
              icon: false,
              timeout: 10000,
            }
          );
          this.deactivateModalClose();
          this.firstLoad();
        })
        .catch((error) => {
          console.error("Error during POST request:", error);
          this.$toast.error(`There was an issue deactivating this user`, {
            hideProgressBar: false,
            position: "bottom-right",
            icon: false,
            timeout: 10000,
          });
        });
    },
    deactivateModalClose() {
      this.deactivateUserOverlay = false;
      this.emailConfirmDeactivate = null;
      this.RepIDConfirmDeactivate = null;
      this.UserToDeactivate = {};
    },
    openEditModal(user) {
      // Set basic user fields
      this.UserToEdit.userName = user.LoweredUserName;
      this.UserToEdit.email = user.LoweredEmail;
      this.UserToEdit.firstName = user.FirstName;
      this.UserToEdit.lastName = user.LastName;
      this.UserToEdit.company = user.ACId;
      
      this.UserToEdit.phoneNumber = user.PhoneNumber;
      this.UserToEdit.department = user.Department;
      this.UserToEdit.userID = user.UserId;
      this.UserToEdit.repId = user.RepId;
      this.UserToEdit.active = user.IsActive;

      // Find User Type from Array
      const validUserTypeIds = [
        "7808307F-10F4-4644-8674-70C4BB4C8BDD", // SSC Employee (Internal)
        "4666CBD3-CD25-488B-B508-DCAB6D358372", // AC (External)
      ];
      const matchingUserTypeId = user.RoleIds.find((roleId) =>
        validUserTypeIds.includes(roleId)
      );
      this.UserToEdit.userType = matchingUserTypeId || "";

      // Find User Level from Array
      const sscRoleIds = [
        "F9FDA66E-262B-408D-8DEC-7E3F02346588", // SSC Employee
        "40F1E2BA-1C81-4E8D-9512-A95C2028A1D5", // SSC Management
        "9F2C80F0-A4B2-435A-BFAA-C56088BA71A5", // SSC Plant 2 Employee
        "B01B1609-92AC-48F3-A1FE-51785448F8C2", // SSC RBM
        "F3C565C9-C65B-4CC9-868B-B0EF74C837F3", // Administrator
      ];
      const acRoleIds = [
        "A9714B0B-6A5C-4524-9A0E-0E6F0D425DF4", // AC Principal
        "D6C4AA1F-22B9-47CF-8386-7FF3E280717A", // AC Salesperson
        "B9AD84BA-7656-447E-8678-2CA8241AF8A6", // AC Admin Assistant
        "9F173158-5856-4F2E-9B25-BDB7514E060D", // AC Marketing
        "F2BA98B3-E5A4-4331-9C6B-DAD131146346", // AC Installer
      ];

      // Choose the appropriate role ID list based on userType
      const validUserLevelIds =
        this.UserToEdit.userType === "7808307F-10F4-4644-8674-70C4BB4C8BDD"
          ? sscRoleIds
          : acRoleIds;

      // Find the first matching role ID for userLevel
      this.UserToEdit.userLevel =
        user.RoleIds.find((roleId) => validUserLevelIds.includes(roleId)) || "";

      // Set Privileges based on RoleIds
      const privilegeGuids = {
        cashManagement: "5D26C210-77BE-41FE-A54E-8599F324A3CF",
        expeditedOrders: "355F9223-FAC7-4F66-BE31-396C2ACFC0EC",
        gsa: "42DB7179-4AD2-42EF-83FC-D4E3AA053F00",
      };

      this.UserToEdit.privileges = {
        cashManagement: user.RoleIds.includes(privilegeGuids.cashManagement)
          ? privilegeGuids.cashManagement
          : false,
        expeditedOrders: user.RoleIds.includes(privilegeGuids.expeditedOrders)
          ? privilegeGuids.expeditedOrders
          : false,
        gsa: user.RoleIds.includes(privilegeGuids.gsa)
          ? privilegeGuids.gsa
          : false,
      };

      // this just sets the array
      // this.UserToEdit.ACId = [...user.CompanyIds];

      //this makes primary company last
      /*
      this.UserToEdit.ACId = [...user.CompanyIds].sort((a, b) => {
        // If a matches company, push it to the end (return 1)
        if (a === this.UserToEdit.company) return 1;
        // If b matches company, keep it at the end (return -1)
        if (b === this.UserToEdit.company) return -1;
        // Otherwise, maintain original order (or sort numerically if desired)
        return 0; // or return a - b for numerical sorting
      });
      alert("made last");
      */

      // This makes primary first

      this.UserToEdit.ACId = [...user.CompanyIds].sort((a, b) => {
        // If a matches company, place it first (return -1)
        if (a === this.UserToEdit.company) return -1;
        // If b matches company, place it first (return 1)
        if (b === this.UserToEdit.company) return 1;
        // Otherwise, maintain original order (or sort numerically if desired)
        return 0; // or return a - b for numerical sorting
      });
      this.UserToEdit.company = this.UserToEdit.ACId[0]
      this.showEditUserOverlay = true;
    },

    CloseEditModal() {
      this.showEditUserOverlay = false;
      this.UserToEdit = {};
    },

    openUserModal() {
      this.generatePassword();
      this.form.password = this.newpassword;
      this.form.confirmPassword = this.newpassword;
      this.showNewUserOverlay = true;
    },
    deleteModalClose() {
      this.deleteUserOverlay = false;
      this.UserToDelete = {};
      this.emailConfirmDelete = "";
    },
    cancelModal() {
      this.deleteUser = "";
      document.body.classList.remove("modal-open");
    },
    insertUser() {},
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      //return value.charAt(0).toUpperCase() + value.slice(1)
      return value.charAt(0) + value.slice(1).toLowerCase();
    },
  },
  computed: {
    activeNav() {
      return this.$store.state.activePage;
    },
    horizontalKeywordRows() {
      if (!this.keywordStats) return []

      const specified = this.keywordStats.specified_keywords || []
      const unigrams   = this.keywordStats.top_unigrams || []
      const bigrams    = this.keywordStats.top_bigrams || []
      const trigrams   = this.keywordStats.top_trigrams || []

      const maxRows = 28
      const rows = []

      for (let i = 0; i < maxRows; i++) {
        rows.push({
          specifiedTerm: specified[i] ? specified[i].term : '',
          specifiedCount: specified[i] ? specified[i].count : '',

          unigramTerm: unigrams[i] ? unigrams[i].term : '',
          unigramCount: unigrams[i] ? unigrams[i].count : '',

          bigramTerm: bigrams[i] ? bigrams[i].term : '',
          bigramCount: bigrams[i] ? bigrams[i].count : '',

          trigramTerm: trigrams[i] ? trigrams[i].term : '',
          trigramCount: trigrams[i] ? trigrams[i].count : ''
        })
      }

      return rows
    },
    repIdInput: {
      get() {
        return this.form.repId.toString(); // Convert to string for input display
      },
      set(value) {
        // Remove hyphens and non-numeric characters, keep only digits
        const sanitized = value.replace(/[^0-9]/g, '');
        // Convert to integer (or 0 if empty/invalid)
        const parsed = sanitized ? parseInt(sanitized, 10) : 0;
        this.form.repId = parsed;
        // Validate
        if (!sanitized || isNaN(parsed)) {
          this.error = 'Please enter a valid integer';
        } else {
          this.error = '';
        }
      },
    },
    EditrepIdInput: {
      get() {
        return this.UserToEdit.repId.toString(); // Convert to string for input display
      },
      set(value) {
        // Remove hyphens and non-numeric characters
        const sanitized = value.replace(/[^0-9]/g, '');
        // Convert to integer (or 0 if empty/invalid)
        const parsed = sanitized ? parseInt(sanitized, 10) : 0;
        this.UserToEdit.repId = parsed;
        // Validate
        if (!sanitized || isNaN(parsed)) {
          this.error = 'Please enter a valid integer';
        } else {
          this.error = '';
        }
      },
    },

    colorGetter() {
      return this.$store.state.colors;
    },

    filteredUserDownload() {
      return this.users.map((user) => ({
        Email: user.Email === undefined || user.Email === null ? "" : user.Email,
        FirstName: user.FirstName === undefined || user.FirstName === null ? "" : user.FirstName,
        LastName: user.LastName === undefined || user.LastName === null ? "" : user.LastName,
        ACId: user.ACId === undefined || user.ACId === null ? null : user.ACId,
        RepId: user.RepId === undefined || user.RepId === null ? null : user.RepId,
        PhoneNumber: user.PhoneNumber === undefined || user.PhoneNumber === null ? "" : user.PhoneNumber,
        Department: user.Department === undefined || user.Department === null ? "" : user.Department,
        Company: user.Name === undefined || user.Name === null ? "" : user.Name,
        IsActive: user.IsActive !== undefined ? user.IsActive : false,
        LastLogin: user.LastLoginDate !== undefined ? user.LastLoginDate : null,
        Roles: this.getRoleNames(user.RoleIds).join(", ") // Comma-separated roles
      }));
    },

    filteredACs: function () {
      let b = this.acs.filter(function (e) {
        return e.ACID <= 200;
      });

      return b;
    },

    //the main v-for loop for the users
    filteredUsers: function () {
      //set the current page to 0
      this.currPage = 1;
      //if the search box is filled in
      if (this.search.trim() !== "") {
        return this.users.filter((e) => {
          return (
            e.FirstName.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            e.LastName.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            e.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );

          //filter the subject line by what is filled in the search box
          //return e.LastName.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        });
      } else if (this.selectedCompany !== "") {
        this.search = "";
        //console.log(this.selectedCat);
        return this.users.filter((f) => {
          return f.Name == this.selectedCompany;
        });
      } else {
        //if the search box is not filled in
        return this.users;
      }
    },

    foundNoUser: function () {
      if (this.search.length > 1 && this.filteredUsers.length === 0) {
        //this.noUserFound = true;
        return true;
      }
    },

    pageStart: function () {
      return (this.currPage - 1) * this.countOfPage;
    },

    totalPage: function () {
      return Math.ceil(this.users.length / this.countOfPage);
    },
  },
  watch: {
    timePeriod(newVal) {
      if (this.view === 'company') this.getCompanyStats();
      else if (this.view === 'user') this.getUserStats();
      else if (this.view === 'keywords') this.getKeywordStats();
    }
},
  created() {
    this.$store.commit("showNavigation");
    // console.log(this.$route.path);
  },
  mounted() {
    this.firstLoad();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #00b4b4;
  border-color: #00b4b4;
}

.user {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}

.top-wrap {
  display: flex;
  align-items: flex-start;
}

.user-bottom {
  align-items: flex-end;
}

.user-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}

.capitalize {
  text-transform: capitalize;
}

.l1 {
  line-height: 1;
}
.mb5 {
  margin-bottom: 5px;
}
.mb10 {
  margin-bottom: 10px;
}
.mr5 {
  margin-right: 5px;
}
.mr10 {
  margin-right: 10px;
}
.mlauto {
  margin-left: auto;
}

.user-link {
  color: #429da8;
  cursor: pointer;
}
.user-link a {
  color: #429da8;
  cursor: pointer;
}
.company-button {
  background: rgb(231 237 241);color: #575757;
  padding: 5px;
  border-radius: 5px;
  transition: background-color 0.5s ease;
}

.info-box {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 2px;
}
.inactive {

}
.admin-buttons {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #429da8;
  color: #fff;
  border-radius: 4px;
  line-height: 1;
  padding: 5px 10px;
  margin-right: 5px;
  cursor: pointer;
}
.admin-btn-wrap {
  display: flex;
  margin-top: 10px;
}
.disabled {
  background-color: #000;
  color: gray;
}
.none {
  display: none;
}
.block {
  display: block;
}

/* radios */
.control-group {
  margin-top: 5px;
  display: inline-block;
  vertical-align: top;
  text-align: left;
}
.control {
  display: inline-block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 5px;
  cursor: pointer;
  font-size: 18px;
  margin-right: 10px;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #e6e6e6;
}
.control--radio .control__indicator {
  border-radius: 50%;
}
.control:hover input ~ .control__indicator,
.control input:focus ~ .control__indicator {
  background: #ccc;
}
.control input:checked ~ .control__indicator {
  background: #4d5967;
}
.control:hover input:not([disabled]):checked ~ .control__indicator,
.control input:checked:focus ~ .control__indicator {
  background: #4d5967;
}
.control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.control__indicator:after {
  content: "";
  position: absolute;
  display: none;
}
.control input:checked ~ .control__indicator:after {
  display: block;
}
.control--checkbox .control__indicator:after {
  left: 8px;
  top: 4px;
  width: 3px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}
.control--radio .control__indicator:after {
  left: 7px;
  top: 7px;
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background: #fff;
}
.control--radio input:disabled ~ .control__indicator:after {
  background: #7b7b7b;
}
.new-search-btn1 {
  background: #4d5967;
  color: #fff;
  border: none;
  transition: background-color 0.5s ease;
  cursor: pointer;
}
.new-search-btn1:hover {
  background: #373f49;
}
.new-search-btn2 {
  background: #6a7b8e;
  color: #fff;
  border: none;
  transition: background-color 0.5s ease;
  cursor: pointer;
}
.new-search-btn2:hover {
  background: #3e4b5a;
}
.dp-custom-input {
  padding: 10px 10px 10px 10px !important;
}
.clear-btn {
  position: absolute;
  right: 0;
  top: 14px;
  border: none;
  background: none;
}
.clear-hide {
  display: none !important;
}
.input-wrap {
  position: relative;
  display: block;
}

.dp__action_cancel {
  color: var(--dp-text-color);
  border: 1px solid var(--dp-border-color);
}

.dp__action_buttons .dp__action_select {
  background: var(--dp-primary-color);
  color: var(--dp-primary-text-color);
}

/* overlay */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.form-container {
  background: white;
  border-radius: 8px;
  padding: 30px;
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.section-header {
  
}

.section-container {
  margin-bottom: 10px;
  padding-left: 12px;
  position: relative; /* Containing block for absolute positioning */
  display: block;
  width: 100%; /* Full width of parent */
}

.section-title {
  font-size: 22px;
  font-weight: 300;
  margin: 0;
  color: #00bcbc;
  display: inline-block; /* Only takes content width */
  position: relative; /* For positioning the line */
  padding-right: 20px; /* Space between title and line */
  display: flex;
  align-items: center;
}

.section-title::after {
  content: '';
  position: absolute;
  top: 50%; /* Center vertically */
  transform: translateY(-50%); /* Adjust for vertical centering */
  left: 100%; /* Start at the right edge of the title */
  width: calc(100% - 20px); /* Extend to the right edge of the parent container */
  height: 1px; /* Thin line */
  background: linear-gradient(to right, #e1e1e1, #f5f5f5); /* Light gray gradient */
}

.section-title svg{
  width: 20px;
  margin-right: 5px;
}

.form-section {
  margin-bottom: 10px;
}

.required::before {
  content: "*\00A0"; /* Asterisk followed by non-breaking space */
  color: red;
  position: relative;
  display: inline-block;
}

.info-icon {
  color: #007bff;
  margin-left: 5px;
  cursor: pointer;
}

.checkbox-group {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  margin-top: 10px;
}

.checkbox-item {
  display: flex;
  align-items: center;
}

.checkbox-item input[type="checkbox"] {
  margin-right: 8px;
}

.btn-close {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.btn-close:hover {
  color: #000;
}

.form-actions {
  margin-top: 30px;
  text-align: right;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  padding: 10px 30px;
  font-weight: 600;
}

.btn-secondary {
  padding: 10px 30px;
  font-weight: 600;
  margin-right: 10px;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-group label {
  color: #575757 !important;
  font-size: 13px !important;
  font-weight: 300 !important;
}
input.form-control {
  background: #f1f6f9 !important;
}
select.form-control {
  background: #f1f6f9 !important;
}
.form-group {
  margin-bottom: 10px;
}
.checkbox-item {
  position: relative;
}

.custom-checkbox {
  /* Hide default checkbox */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  position: relative;
  outline: none;
}

.custom-checkbox + label {
  cursor: pointer;
}

/* Custom checkbox unchecked state */
.custom-checkbox + label::before {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #ced4da; /* Default border color */
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

/* Custom checkbox checked state */
.custom-checkbox:checked + label::before {
  background-color: #00bcbc !important; /* Your desired color */
  border-color: #00bcbc !important;
}

/* Optional: Add checkmark for checked state */
.custom-checkbox:checked + label::after {
  content: "\2713"; /* Unicode checkmark */
  color: white;
  font-size: 12px;
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
}
.admin-buttons {
  transition: transform 0.2s;
  transform: scale(1);
}
.admin-buttons:hover {
  transform: scale(1.05);
}
.tooltip-label {
  position: relative; /* Required for positioning the tooltip */
  cursor: pointer; /* Optional: Indicates interactivity */
}

/* Tooltip text */
.tooltip-label::after {
  content: attr(data-tooltip); /* Use data-tooltip attribute for content */
  position: absolute;
  top: -30px; /* Position above the label */
  left: 50%;
  transform: translateX(-50%); /* Center horizontally */
  background-color: #333; /* Dark background */
  color: #fff; /* White text */
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap; /* Prevent text wrapping */
  opacity: 0; /* Hidden by default */
  visibility: hidden; /* Hidden by default */
  transition: opacity 0.2s, visibility 0.2s; /* Smooth transition */
  z-index: 1100; /* Ensure it’s above other elements */
}

/* Show tooltip on hover */
.tooltip-label:hover::after {
  opacity: 1;
  visibility: visible;
}

/* Optional: Add a small arrow below the tooltip */
/*
.tooltip-label::before {
  content: '';
  position: absolute;
  top: -8px; 
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: #333; 
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s, visibility 0.2s;
}

.tooltip-label:hover::before {
  opacity: 1;
  visibility: visible;
}
  */

.filter-btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border: none;
    /* background: #519bb2; */
    background: #4d5967;
    color: #fff;
    border-radius: 4px;
    padding: 5px;
    cursor: pointer;
    max-height: 40px;
}
.horizontal-keyword-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  font-size: 0.95rem;
}

.horizontal-keyword-table th,
.horizontal-keyword-table td {
  padding: 10px 12px;
  border: 1px solid #ccc;
  text-align: left;
  vertical-align: top;
}

.horizontal-keyword-table .category-header {
  background: #4d5967;
  color: white;
  padding: 6px;
}

.horizontal-keyword-table thead tr:first-child th {
  border-bottom: 3px solid #34495e;
}

.horizontal-keyword-table tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}

.horizontal-keyword-table td:empty {
  background-color: #f1f1f1;
  color: #aaa;
}
</style>
<style>
#adminCompanies .vs__dropdown-menu {
  background: #f1f6f9 !important;
}
</style>
